import classNames from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import type { LoaderProps } from 'semantic-ui-react';
import { Loader } from 'semantic-ui-react';

import s from './component-loader.scss';

/**
 * A loading spinner that uses a lower z-index, suitable for low-level component
 * loading states. Avoids cases where the default layer is higher than other
 * top-level layout components, e.g. Page Header/Footer.
 */
export const ComponentLoader = ({ className, ...props }: LoaderProps) => {
  useStyles(s);

  return (
    <Loader
      role="status"
      className={classNames(s.componentLoader, className)}
      {...props}
    />
  );
};

export default ComponentLoader;
